import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantShopRefillStockPage } from './merchant-shop-refill-stock';

@NgModule({
  declarations: [
    MerchantShopRefillStockPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantShopRefillStockPage),
    TranslateModule.forChild()
  ],
})
export class MerchantShopRefillStockPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-shop-refill-stock/merchant-shop-refill-stock.module.ts